var map = {
	"./assets/clickable/etsy.svg": "12a92c6e03cbc903614a",
	"./assets/disabled/etsy.svg": "52710261e897919dd740",
	"./assets/original/etsy.svg": "31ea4cf8c65804c04175"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "817b52198e04ef1e92a3";